import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackCanvasUploadOptionSelected.meta';

export type UseTrackCanvasUploadOptionSelectedParams = {
  action_taken: 'upload_from_computer' | 'add_from_board';
  location: 'bottom_toolbar' | 'context_menu' | 'tool_rail_search' | 'tool_rail_pinned';
  canvas_id?: string;
};

export const useTrackCanvasUploadOptionSelected = () => {
  const { track } = useAnalyticsUtilities();

  const trackCanvasUploadOptionSelected = useCallback(
    (params: UseTrackCanvasUploadOptionSelectedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackCanvasUploadOptionSelected };
};
